import { addMethod, string, number } from "yup";
import emailOrPhone from "~/utils/check/email-or-phone";
import phone from "~/utils/check/phone";

// Custom validation function for username
export const addUsernameMethod = () => {
    addMethod(string, "username", function (message) {
        return this.test("username", message, function (value) {
            const { path, createError } = this;
            return emailOrPhone(value) || createError({ path, message: message || "لطفا تنها شماره موبایل یا ایمیل خود را وارد نمایید" });
        });
    });
};

// Custom validation function for phone numbers
export const addPhoneMethod = () => {
    addMethod(string, "phone", function (message) {
        return this.test("phone", message, function (value) {
            const { path, createError } = this;
            return phone(value) || createError({ path, message: message || "شماره موبایل باید با 09 شروع شود و 11 رقم باشد" });
        });
    });
};